import type { BaseOrganisation } from 'services/assist-api/entities/customers/customers';
import type { Me } from 'services/assist-api/entities/me/me';
import { ROLE } from 'services/assist-api/entities/role/roles';
import { useAuth } from './auth.provider';

export const useRoleMatch = (roles: string[], acceptSiteAdmin = true): boolean => {
  const { me } = useAuth();
  const includesCustomerRole = !!me?.customerRoles?.find((role) => roles.includes(role));
  const isSiteAdmin = !!me?.systemRoles?.find((role) => [ROLE.SITE_ADMIN].includes(role));
  return includesCustomerRole || (acceptSiteAdmin && isSiteAdmin);
};

export const useIsSiteAdmin = (): boolean => useRoleMatch([]);

export const useAuthCustomer = (): BaseOrganisation | undefined => {
  const { me } = useAuth();
  return me?.customer;
};

// Is a primary, intermediate, or secondary school (e.g. not university)
export const useIsSchool = (): boolean => {
  const customer = useAuthCustomer();
  return customer?.customerType?.id === 1;
};

export const useAuthCustomerUser = (): Me['customerUser'] => {
  const { me } = useAuth();
  return me?.customerUser;
};
